import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcCompaniesInputModule } from '@core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcLocationGroupsInputModule } from '@core/components/fc-input/search-many/fc-location-groups-input/fc-location-groups-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterComponent } from './filter.component';

@NgModule({
  declarations: [
    FilterComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,

    FcDateInputModule,
    FcMaintenanceTypesInputModule,
    FcSegmentsInputModule,
    FcLocationsInputModule,
    FcCompaniesInputModule,
    FcLocationGroupsInputModule,
  ],
  exports: [
    FilterComponent
  ]
})
export class FilterModule { }
